import { Play, ShieldCheck, Zap } from "lucide-react";

export const Hero = ({ onCta }) => (
  <section data-testid="hero-section" className="relative pt-20 pb-24 sm:pt-28 sm:pb-32 px-4 sm:px-6">
    {/* Glow background */}
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      <div className="absolute -top-40 left-1/2 -translate-x-1/2 w-[800px] h-[500px] rounded-full bg-[#FF5A00]/15 blur-[120px]" />
      <div className="absolute top-40 right-0 w-[400px] h-[300px] rounded-full bg-[#25D366]/10 blur-[100px]" />
    </div>

    <div className="relative max-w-5xl mx-auto text-center">
      <div className="fade-up inline-flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-1.5 text-xs sm:text-sm text-white/70 mb-8">
        <span className="w-2 h-2 rounded-full bg-[#25D366] animate-pulse" />
        +1.250 clientes ativos · Avaliação 4.8 estrelas
      </div>

      <h1
        className="fade-up fade-up-delay-1 text-4xl sm:text-5xl lg:text-7xl font-black tracking-tighter leading-[1.05] mb-6"
        style={{ fontFamily: "Outfit, sans-serif" }}
      >
        O Melhor do Entretenimento <br className="hidden sm:block" />
        na <span className="text-[#FF5A00]">Sua Tela</span>
      </h1>

      <p className="fade-up fade-up-delay-2 text-base md:text-lg text-white/60 max-w-2xl mx-auto mb-10">
        Milhares de canais ao vivo, filmes e séries em HD/4K sem travamentos com tecnologia P2P.
        Assista de qualquer lugar, a partir de <strong className="text-white">R$30/mês</strong>.
      </p>

      <div className="fade-up fade-up-delay-3 flex flex-col sm:flex-row items-center justify-center gap-4 mb-12">
        <button
          data-testid="cta-hero"
          onClick={() => onCta("hero")}
          className="w-full sm:w-auto bg-[#FF5A00] hover:bg-[#FF7A33] text-white font-bold rounded-lg px-8 py-4 text-lg transition-all shadow-[0_0_30px_rgba(255,90,0,0.5)] hover:scale-[1.03] flex items-center justify-center gap-2"
        >
          <Play className="w-5 h-5 fill-white" />
          Quero Assistir Agora
        </button>
        <button
          data-testid="cta-hero-planos"
          onClick={() => document.getElementById("planos")?.scrollIntoView({ behavior: "smooth" })}
          className="w-full sm:w-auto bg-white/5 hover:bg-white/10 border border-white/15 text-white font-semibold rounded-lg px-8 py-4 text-lg transition-colors"
        >
          Ver Planos
        </button>
      </div>

      <div className="fade-up fade-up-delay-3 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm text-white/50">
        <span className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#25D366]" /> Tecnologia P2P estável</span>
        <span className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#FF5A00]" /> Ativação imediata</span>
        <span className="flex items-center gap-2"><Play className="w-4 h-4 text-[#FF5A00]" /> Qualidade HD/4K</span>
      </div>
    </div>
  </section>
);
